module.exports = __webpack_public_path__ + "static/media/hands.bcb72a65.svg";